import { ApplicationConfig, provideZoneChangeDetection, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { requestAuthInterceptor, responseInterceptor, SPECTRUM_API_PATH, SPECTRUM_AUTH_API, provideSpectrumGuide } from 'common';
import { environment } from '../environments/environment';
import { LUCIDE_ICONS, LucideIconProvider } from 'lucide-angular';
import {
    LayoutDashboard, Landmark, Network, CalendarDays, Sparkles, Settings,
    ChevronDown, ChevronRight, ChevronLeft, Plus, Check, X, Menu, Bell,
    PanelLeftClose, PanelLeftOpen, AlertCircle, Save, Trash2, Search,
    GraduationCap, ArrowUp, ArrowDown, ArrowRight, Repeat, Clock, FileText, LogOut
} from 'lucide-angular';

export const appConfig: ApplicationConfig = {
    providers: [
        provideSpectrumGuide({
            module: 'institute',
            title: 'Institute',
            manual: () => import('./help/institute.manual').then(m => m.INSTITUTE_MANUAL)
        }),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideBrowserGlobalErrorListeners(),
        provideRouter(routes),
        provideHttpClient(withInterceptors([requestAuthInterceptor, responseInterceptor])),
        provideAnimations(),
        { provide: SPECTRUM_API_PATH, useValue: environment.externalApiPath },
        { provide: SPECTRUM_AUTH_API, useValue: environment.authBaseUrl },
        {
            provide: LUCIDE_ICONS,
            multi: true,
            useValue: new LucideIconProvider({
                LayoutDashboard, Landmark, Network, CalendarDays, Sparkles, Settings,
                ChevronDown, ChevronRight, ChevronLeft, Plus, Check, X, Menu, Bell,
                PanelLeftClose, PanelLeftOpen, AlertCircle, Save, Trash2, Search,
                GraduationCap, ArrowUp, ArrowDown, ArrowRight, Repeat, Clock, FileText, LogOut
            })
        }
    ]
};
